import React, { useState, useEffect } from 'react';
import { MapContainer, TileLayer, Circle, Popup } from 'react-leaflet';
import { Container, Button, Form, Row, Col, Card, Table } from 'react-bootstrap';
import { FaPlus, FaSave, FaTimes, FaEdit, FaTrash } from 'react-icons/fa';
import 'leaflet/dist/leaflet.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Danger_Zone.css';  // Ensure this path is correct and the CSS file is properly configured
import {BASE_URL} from '../../Constants/constants'
const API_URL = `${BASE_URL}/danger_cities/`;

const cityData = [
    { name: "Port-au-Prince", lat: 18.5333, lng: -72.3333 },
    { name: "Carrefour", lat: 18.5344, lng: -72.4094 },
    { name: "Pétion-Ville", lat: 18.5128, lng: -72.2864 },
    { name: "Gonaïves", lat: 19.4456, lng: -72.6883 },
    { name: "Croix-des-Bouquets", lat: 18.5761, lng: -72.2269 },
    { name: "Delmas", lat: 18.55, lng: -72.3 },
    { name: "Cap-Haïtien", lat: 19.76, lng: -72.2 },
    { name: "Petite Rivière de l’Artibonite", lat: 19.1333, lng: -72.4833 },
    { name: "Saint-Marc", lat: 19.1167, lng: -72.7 },
    { name: "Jean-Rabel", lat: 19.85, lng: -73.2 },
    { name: "Jacmel", lat: 18.2353, lng: -72.5367 },
    { name: "Arcahaie", lat: 18.7667, lng: -72.5167 },
    { name: "Tabarre", lat: 18.5833, lng: -72.2667 },
    { name: "Dessalines", lat: 19.2833, lng: -72.5 },
    { name: "Port-de-Paix", lat: 19.95, lng: -72.8333 },
    { name: "Aquin", lat: 18.2833, lng: -73.4 },
    { name: "Hinche", lat: 19.15, lng: -72.0167 },
    { name: "Léogâne", lat: 18.5108, lng: -72.6339 },
    { name: "Les Cayes", lat: 18.2, lng: -73.75 },
    { name: "Saint-Louis du Nord", lat: 19.9333, lng: -72.7167 },
    { name: "Limbe", lat: 19.7056, lng: -72.4147 },
    { name: "Limonade", lat: 19.6667, lng: -72.1167 },
    { name: "Miragoâne", lat: 18.4458, lng: -73.09 },
    { name: "Plaisance", lat: 19.6, lng: -72.4667 },
    { name: "Pilate", lat: 19.6667, lng: -72.55 },
    { name: "Port-Margot", lat: 19.75, lng: -72.4333 },
    { name: "Fort Liberté", lat: 19.6678, lng: -71.8397 },
    { name: "Saintard", lat: 18.824, lng: -72.55 },
    { name: "Milot", lat: 19.6047, lng: -72.2186 },
    { name: "Jérémie", lat: 18.65, lng: -74.1167 },
    { name: "Liancourt", lat: 19.1356, lng: -72.5333 },
    { name: "Petit-Goâve", lat: 18.4314, lng: -72.8669 },
    { name: "La Pointe", lat: 19.95, lng: -72.7833 },
    { name: "Gros Morne", lat: 19.6667, lng: -72.6833 }
];

const DangerZone = () => {
    const [areas, setAreas] = useState([]);
    const [selectedCity, setSelectedCity] = useState('');
    const [editableId, setEditableId] = useState(null);
    const [formData, setFormData] = useState({ name: '', danger_rating: '', latitude: '', longitude: '' });
    const [panelOpen, setPanelOpen] = useState(false);

    useEffect(() => {
        fetchAreas();
    }, []);

    // const fetchAreas = () => {
    //     fetch(`${API_URL}`)
    //         .then(response => response.json())
    //         .then(data => setAreas(data))
    //         .catch(error => console.error('Error fetching area data:', error));
    // };
    const fetchAreas = () => {
        fetch(`${API_URL}`)
            .then(response => response.json())
            .then(data => {
                if (Array.isArray(data)) {
                    setAreas(data);
                } else {
                    console.error('Fetched data is not an array:', data);
                    setAreas([]); // Set an empty array as a fallback
                }
            })
            .catch(error => {
                console.error('Error fetching area data:', error);
                setAreas([]); // Set an empty array as a fallback
            });
    }

    const handleCityChange = (event) => {
        const selectedCity = event.target.value;
        setSelectedCity(selectedCity);
        const city = cityData.find(city => city.name === selectedCity);
        setFormData({
            ...formData,
            name: city ? city.name : '',
            latitude: city ? city.lat : '',
            longitude: city ? city.lng : '',
        });
    };
    const getColor = (dangerRating) => {
        switch (dangerRating) {
            case 'high':
                return 'red';
            case 'medium':
                return 'yellow';
            case 'low':
                return 'green';
            default:
                return 'gray';
        }
    };

    const handleFormChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleAddClick = () => {
        setEditableId(null);
        setFormData({ name: '', danger_rating: '', latitude: '', longitude: '' });
        setPanelOpen(true);
    };

    const handleEditClick = (area) => {
        setEditableId(area.id);
        setFormData(area);
        setPanelOpen(true);
    };
    const handleRatingChange = (event) => {
        setFormData({ ...formData, danger_rating: event.target.value });
    };

    // const handleSave = () => {
    //     const method = editableId ? 'PUT' : 'POST';
    //     const url = editableId ? `${API_URL}${editableId}/` : API_URL;
    //
    //     fetch(url, {
    //         method: method,
    //         headers: { 'Content-Type': 'application/json' },
    //         body: JSON.stringify(formData),
    //     })
    //         .then(response => response.json())
    //         .then(() => {
    //             fetchAreas();
    //             setPanelOpen(false);
    //             setEditableId(null);
    //             setFormData({ name: '', danger_rating: '', latitude: '', longitude: '' });
    //         })
    //         .catch(error => console.error('Error saving area:', error));
    // };
    const handleSave = () => {
        const method = editableId ? 'PUT' : 'POST';
        const url = editableId ? `${API_URL}${editableId}/` : API_URL;

        fetch(url, {
            method: method,
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(formData),
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then((savedCity) => {
                if (editableId) {
                    // Update the area in the local state without reloading the page
                    setAreas(areas.map(area => area.id === editableId ? savedCity : area));
                } else {
                    // Add the new area to the local state without reloading the page
                    setAreas([...areas, savedCity]);
                }
                setPanelOpen(false);
                setEditableId(null);
                setFormData({ name: '', danger_rating: '', latitude: '', longitude: '' });
            })
            .catch(error => {
                console.error('Error saving area:', error);
            });
    };

    const handleDelete = (id) => {
        fetch(`${API_URL}${id}/`, { method: 'DELETE' })
            .then(() => fetchAreas())
            .catch(error => console.error('Error deleting area:', error));
    };

    const handleCancel = () => {
        setPanelOpen(false);
        setEditableId(null);
        setFormData({ name: '', danger_rating: '', latitude: '', longitude: '' });
    };

    return (
        <Container fluid style={{ height: '100vh' }}>
            <Row className="h-100">
                <Col md={panelOpen ? 6 : 11} className="p-0 position-relative">
                    <div className="map-header">Danger Zone</div>
                    <MapContainer center={[18.594395, -72.307433]} zoom={8} style={{ height: '100%', width: '100%' }}>
                        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                        {areas.map((area) => (
                            <Circle key={area.id} center={[parseFloat(area.latitude), parseFloat(area.longitude)]}
                                    color={getColor(area.danger_rating)}
                                    fillColor={getColor(area.danger_rating)} fillOpacity={0.8} radius={4000}>
                                <Popup>{`${area.name} - Danger Rating: ${area.danger_rating}`}</Popup>
                            </Circle>
                        ))}
                    </MapContainer>
                    <Button variant="primary" onClick={handleAddClick} className="add-area-button" title="Add Area">
                        <FaPlus />
                    </Button>
                </Col>
                <Col md={panelOpen ? 6 : 1} className="p-0">
                    <Card className={`panel-container ${panelOpen ? 'open' : ''}`} style={{ width: '50%', height: '100%' }}>
                        <Card.Body>
                            <Card.Title>Add City</Card.Title>
                            <Form>
                                <Form.Group className="mb-3">
                                    <Form.Label>Name</Form.Label>
                                    <Form.Control as="select" value={selectedCity} onChange={handleCityChange}>
                                        <option value="">Select City...</option>
                                        {cityData.map(city => (
                                            <option key={city.name} value={city.name}>{city.name}</option>
                                        ))}
                                    </Form.Control>
                                    {/*<Form.Control type="text" placeholder="Name" name="name" value={formData.name} onChange={handleFormChange} />*/}
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Label>Danger Rating</Form.Label>
                                    <Form.Control as="select" name="danger_rating" value={formData.danger_rating} onChange={handleFormChange}>
                                        <option value="">Select...</option>
                                        <option value="high">High</option>
                                        <option value="medium">Medium</option>
                                        <option value="low">Low</option>
                                    </Form.Control>
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Label>Latitude</Form.Label>
                                    <Form.Control type="text" placeholder="Latitude" name="latitude" value={formData.latitude} readOnly />
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Label>Longitude</Form.Label>
                                    <Form.Control type="text" placeholder="Longitude" name="longitude" value={formData.longitude} readOnly />
                                </Form.Group>
                                <Button variant="primary" onClick={handleSave}><FaSave /> Save</Button>
                                <Button variant="secondary" onClick={handleCancel} className="ms-2"><FaTimes /> Cancel</Button>
                            </Form>
                            <Table striped bordered hover size="sm">
                                <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Danger Rating</th>
                                    <th>Latitude</th>
                                    <th>Longitude</th>
                                    <th>Actions</th>
                                </tr>
                                </thead>
                                <tbody>
                                {areas.map((area) => (
                                    <tr key={area.id}>
                                        <td>{area.name}</td>
                                        <td>{area.danger_rating}</td>
                                        <td>{area.latitude}</td>
                                        <td>{area.longitude}</td>
                                        <td>
                                            <Button variant="info" size="sm" onClick={() => handleEditClick(area)}><FaEdit /></Button>
                                            <Button variant="danger" size="sm" onClick={() => handleDelete(area.id)}><FaTrash /></Button>
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </Table>
                        </Card.Body>
                    </Card>
                    <div className={`overlay ${panelOpen ? 'open' : ''}`} onClick={handleCancel}></div>
                </Col>
            </Row>
        </Container>
    );
};

export default DangerZone;
